import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { ShieldCheck, Building2, LogOut, BarChart3, CreditCard, BookOpen } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function PlatformLayout({ children }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = () => {
    logout();
    nav("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#F5F3EC]">
      {/* Top bar */}
      <header className="bg-[#0b1721] text-white border-b border-black/20">
        <div className="max-w-[1400px] mx-auto px-6 py-3 flex items-center gap-4">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-xl bg-brand flex items-center justify-center">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-wider opacity-70">MediFlow Platform</div>
              <div className="font-heading font-bold">Super Admin Console</div>
            </div>
          </div>
          <nav className="ml-8 flex items-center gap-1 text-sm">
            <NavItem to="/platform/tenants" icon={Building2} label="Tenants" />
            <NavItem to="/platform/plans" icon={CreditCard} label="Plans" />
            <NavItem to="/platform/documentation" icon={BookOpen} label="Documentation" />
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm">
            <div className="hidden sm:block text-right">
              <div className="font-semibold">{user?.first_name} {user?.last_name}</div>
              <div className="text-xs opacity-70">{user?.email}</div>
            </div>
            <button onClick={doLogout} data-testid="sa-logout"
              className="h-10 px-3 rounded-lg bg-white/10 hover:bg-white/20 text-white flex items-center gap-2 text-sm">
              <LogOut className="w-4 h-4" /> Déconnexion
            </button>
          </div>
        </div>
      </header>

      {/* Privacy banner */}
      <div className="bg-[#e3a03b]/20 border-b border-[#e3a03b]/40">
        <div className="max-w-[1400px] mx-auto px-6 py-2 text-xs text-[#8a5a10] flex items-center gap-2">
          <ShieldCheck className="w-4 h-4" />
          Les données opérationnelles des cliniques restent privées — cette console n'affiche que des agrégats.
        </div>
      </div>

      <main className="max-w-[1400px] mx-auto px-6 py-6">{children}</main>
    </div>
  );
}

function NavItem({ to, icon: Icon, label }) {
  return (
    <NavLink to={to}
      className={({ isActive }) =>
        `h-9 px-3 rounded-lg font-semibold flex items-center gap-2 transition-colors ${isActive ? "bg-white/15 text-white" : "text-white/70 hover:bg-white/10 hover:text-white"}`
      }
    >
      <Icon className="w-4 h-4" /> {label}
    </NavLink>
  );
}
